import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import SliderWrapper from "jd-library/SliderWrapper";
import historyHandler from "jd-library/historyHandler";
import InputWithMovingLabel from "jd-library/InputWithMovingLabel";
import axios from 'axios';
import InputWithDropDown from '../InputWithDropDown/InputWithDropDown';
import styles from './tax_slider.scss';
import ItemListSlider from "../Item-List-Slider/ItemListSlider";
import SearchResults from "./SearchResults";
import Loader from "jd-library/Loader";
// import { getApplicableTax } from "../../utills";
import Dropdown from 'jd-library/Dropdown';
import toastMessageActions from 'jd-library/toastMessageActions';

const TaxSlider = props => {
    let { heading, headerVariant, onHidden, onSubmit, initialData, isMobile, session } = props;
    let [taxIdPair, setTaxIdPair] = useState(null);
    let [zoneIds, setZoneIds] = useState(null);
    let [taxLabel, setTaxLabel] = useState(null);
    let [formData, setFormData] = useState(initialData || {});
    let [showHsnSlider, setHsnSlider] = useState(false);
    let [searchLoaderFlag, toggleSearchLoaderFlag] = useState(false);
    let [hsnSacData, setHsnSacData] = useState([]);
    let [hsnSearchVal, setHsnSearchVal] = useState('');
    let [showLoader, setLoader] = useState(false);
    let [taxDetails, setTaxDetails] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    let [purchaseTaxLabel, setPurchaseTaxLabel] = useState(null);
    let [purchaseTaxDetail, setPurchaseTaxDetail] = useState([]);
    let isRetail = (props.supplierType == "B2C");
    let hsnRef = useRef(null);
    let [outletData, setOutletData] = useState(props.outletData || []);
    const [errors,updateError] = useState({});
    const rippleColor = 'rgba(64,125,255,0.1)';
    const onItemSelect = (serviceKey, value) => {
        let error = {...errors};
        error[serviceKey] = '';
        updateError(error);
        setFormData(formData => ({
            ...formData,
            [serviceKey]: value
        }));
    }

    const validateFields = () => {
        let errMsg = '';
        let error = {...errors};
        // let taxPer = [];
        if(!formData['HSN/SAC']){
            errMsg = 'Please Enter HSN/SAC code';
            error['hsn'] = 'Please Enter HSN/SAC code'; 
        }
        // if (zoneIds && zoneIds.length) {
        //     zoneIds.map((cur,index) => {
        //         if(!formData[cur.zoneName]){
        //             errMsg = errMsg ? errMsg : 'Please Enter Taxes '+cur.zoneName;
        //             error[cur.zoneName] = 'Please Enter Taxes '+cur.zoneName;
        //         }else {
        //             taxPer[index] = Number(formData[cur.zoneName].split('@')[1].split('%')[0].trim());
        //         }
        //     })
        // }
        if(!formData['salestax']){
            errMsg = errMsg || 'Please Enter Sales Taxes';
            error['salestax'] = 'Please Enter Sales Taxes';
        }
        updateError(error);
        // if(!errMsg && taxPer[0] != taxPer[1]) {
        //     errMsg = 'Tax Details are not Valid'
        // }
        return errMsg;
    }
    const prepareServiceData = () => {
        let errorMsg = false; //validateFields();
        if(errorMsg){
            props.showMessage({
                message: errorMsg,
                type: 'error'
            });
            return;
        }
        // let salesTax = [];
    //     if (zoneIds && zoneIds.length) {
    //     zoneIds.map((ele, index) => {
    //         let taxName = formData[ele.zoneName] || '';
    //         let temp = {
    //             zoneId: ele.zoneId,
    //             taxId: taxName ? taxIdPair[taxName] : ''
    //         }
    //         salesTax.push(temp);
    //     })
    // }
        let purchaseTaxName = formData['purchaseTax'] || '';
        let purchaseTax = [{
            zoneId: '',
            taxId: purchaseTaxName ? taxIdPair[purchaseTaxName] : ''
        }]
        let gstCess = '0.00';
        let gstRate = formData['salestax']?.replace('%','');
        for(let i=0 ; i < props.taxData?.length; i += 1){
            if(props.taxData[i].taxRate === gstRate){
                for(let j=0; j < props.taxData[i]?.linkedTaxes?.length; j += 1){
                    if(props.taxData[i].linkedTaxes[j]?.taxName === 'Additional Cess'){
                        gstCess = props.taxData[i].linkedTaxes[j]?.taxValue;
                    }
                }
            }
        }
        let responseData = {
            purchaseTax: purchaseTax,
            hsnSacNo: formData['HSN/SAC'] || '',
            gstRate,
            gstCess
        }
        onSubmit(responseData, formData);
        historyHandler.closeCurrent();
    }

    let inputElements = [{
        label: 'HSN/SAC Code',
        holderClass: `input-ele hsn-slider ${((props.productData.isTempProd || props.productData.isTemplate) && props.productData.hsnPresent && formData['HSN/SAC']) || ( !props.productData.hsnEditable && props.productData.productId !='ADD_PRODUCT' )?'disable-div':''}`,
        showArrow:  false,
        // disableMovingLabel: !formData['HSN/SAC'],
        input: {
            value: formData['HSN/SAC'] || '',
            onClick: () => {
                let error = {...errors};
                error['hsn'] = '';
                updateError(error);
                setHsnSlider(true);
            },
            readOnly: true
        },
        errorMessage: errors['hsn'],
        inputGroupProps:{
            rightIconClass: (formData['HSN/SAC'] && props.productData.isTempProd && props.productData.hsnPresent) ||( !props.productData.hsnEditable && props.productData.productId !='ADD_PRODUCT' )?'':formData['HSN/SAC'] ? 'icon-HDRcross' : `icon-pagination-right hsn-slider-icon`,
            onRightIconClick: () => {
                if(!formData['HSN/SAC']){
                    setHsnSlider(true);
                    return;
                }
                if(formData['HSN/SAC'] && !props.productData.isTempProd){
                    setHsnSearchVal('');
                }
                let newFormData = {};
                if(formData.purchaseTax){
                    newFormData.purchaseTax = formData.purchaseTax;
                }
                if(props.productData.taxPresent || (!props.productData.taxEditable && props.productData.productId != 'ADD_PRODUCT')){
                    newFormData = initialData;
                    newFormData['HSN/SAC'] = '';
                }
                setFormData(newFormData);
                setHsnSearchVal('');
            }
        }
    },
    {
        containerClass: 'input-ele disable-div4',
        label: 'Select Sales tax',
        fieldName: "SalesTaxRate",
        onItemSelect: (value) => {
            if(value == 'Select Tax')
                value = '';//Clear selection
            onItemSelect('salestax', value);
        },
        value:  formData['salestax'] || '',
        isSelect: true,
        serviceKey: 'salestax',
        selectedItem: formData['salestax']
    }
];

let purchaseTaxArrtibutes = {
    containerClass: 'input-ele',
    label: 'Purchase Tax',
    ignoreDisabling: true,
    isPurchase:true,
    onItemSelect: (value) => {
        if(value == 'Select Tax')
            value = '';
        onItemSelect('purchaseTax', value);
    },
    selectedItem: formData['purchaseTax'],
    serviceKey: 'purchaseTax',
    isSelect: true,
    value: formData['purchaseTax'],
    ...(props.isMobile ? {} : {
        value: formData['purchaseTax'],
        label: formData['purchaseTax'] ? 'Purchase Tax' : "Select Purchase Tax",
        onChange: (e) => {
            let value = e.label;
            if(value == 'Select Tax')
                value = '';
            onItemSelect('purchaseTax', value);
        },
        placeholder: 'Purchase Tax'
    })
}

if(props?.session?.viaOmni) {
    inputElements.push(purchaseTaxArrtibutes);
}
    
    const getDropDownOptions = (dropDownList, label) => {
        let dropDownListArr = dropDownList.map((item) => ({ label: item , key: item }));

        // dropDownList.forEach(item => {
        //     if(item.includes('IGST') || item.includes('IGST+CESS') || item.includes('SGST+CGST') || item.includes('SGST+CGST+CESS') || item.includes('UTGST+CGST') ||item.includes('UTGST+CGST+CESS')){
        //         if(label.includes('Outside') && item.includes('IGST')){
        //             let key = item.key ? item.key: item;
        //             let value = item.label ? item.label: item;
        //             dropDownListArr.push({
        //                 label: value,
        //                 key: key,
        //             })
        //         }
        //         else if(label.includes('Within') && !item.includes('IGST')){
        //             let key = item.key ? item.key: item;
        //             let value = item.label ? item.label: item;
        //             dropDownListArr.push({
        //                 label: value,
        //                 key: key,
        //             })
        //         }
        //     }
         
        // });

        return dropDownListArr;
    }

    if (zoneIds && zoneIds.length) {
        zoneIds.map((ele, index) => {
            let serviceKey = ele.zoneName;
            let temp = {};
            if(props.manageTaxes){
                temp = {
                    label: ele.zoneName,
                    holderClass: 'input-ele '+(formData[serviceKey] && props.productData.tax?'disable-div4':''),
                    value:  formData[serviceKey],
                    isSelect: true,
                    serviceKey,
                    // input: {
                    //     as: 'select',
                    //     value:  formData[serviceKey] || '',
                    //     onChange:(e) => {
                    //         let value = e.target.value;
                    //         if(value == 'Select Tax')
                    //             value = '';//Clear selection
                    //         onItemSelect(serviceKey, value);
                    //     },
                    //     children: getDropDownOptions(taxLabel)
                    // }
                }
            }else{
                temp = {
                    containerClass: 'input-ele '+(formData[serviceKey] && props.productData.tax?'disable-div4':''),
                    label: ele.zoneName,
                    onItemSelect: (value) => {
                        if(value == 'Select Tax')
                            value = '';//Clear selection
                        onItemSelect(serviceKey, value);
                    },
                    selectedItem: formData[serviceKey],
                    isSelect: true,
                }
            }
            inputElements.push(temp);
        })
    }



    // if (isRetail) {
    //     inputElements.push({
    //         containerClass: 'input-ele',
    //         label: 'Purchase Tax',
    //         onItemSelect: (value) => {
    //             if(value == 'Select Tax')
    //                 value = '';
    //             onItemSelect('purchaseTax', value);
    //         },
    //         selectedItem: formData['purchaseTax'],
    //         isSelect: true
    //     });
    // }

    useEffect(() => {
        if (!taxIdPair) {
            let data = {
                tax: props.taxData,
                taxZones: props.taxZoneData
            }
            let taxDetails = data.tax;
            let taxArray = [],
                taxIdPair = {};
                taxDetails?.forEach((ele) => {
                    if(ele.taxCode === 'IGST'){
                        let label = ele.taxRate + '%';
                        taxArray.push(label);
                        taxIdPair[label] = ele.taxId;
                    }
                })   
            taxArray.unshift('Select Tax');
            setTaxLabel(taxArray);
            // setZoneIds(data.taxZones);
            setTaxDetails(taxDetails);
            setTaxIdPair(taxIdPair);

            if(props?.session?.viaOmni) {
                data.purchaseTax = props.purchaseTaxData;
                let _purchaseTaxDetail = data.purchaseTax;
            
                let purchaseTaxArray = [];
                
                _purchaseTaxDetail && _purchaseTaxDetail.map((ele, index) => {
                    let label = ele.taxName + ' @ ' + ele.taxRate + '%';
                    purchaseTaxArray.push(label);
                    taxIdPair[label] = ele.taxId;
                }) 
                purchaseTaxArray.unshift('Select Tax');
                setPurchaseTaxLabel(purchaseTaxArray);
                setPurchaseTaxDetail(_purchaseTaxDetail);
            }

            outletData.map((outlet, index) => {
                axios
                    .get('/marketplace/gis/getDetailByPincode.service?pincode=' + outlet.pincode + '&priority=1')
                    .then(res => {
                        if (res.data.result[0]) {
                            outlet.state_id = res.data.result[0].state_id + "";
                        }
                        if (index == outletData.length - 1)
                            setOutletData(outletData);
                    });
            })
        }
    }, []);

    useEffect(() => {
        if(showHsnSlider && !formData['HSN/SAC']) {
            if(props.psv_node_id ) {
                axios
                    .get("/marketplace/static/php/web/common_api.php", {
                        params: {
                            action: 'getGstFromHsn',
                            currentPage: 1,
                            searchBy: '',
                            psv_node_id: props.psv_node_id
                        }
                    }).then(res => {
                        let searchRslts = res.data && res.data.docs;
                        if (searchRslts && searchRslts.length) {
                            setHsnSacData(searchRslts);
                        } else {
                            setHsnSacData([]);
                            console.log("No Result Found");
                        }
                    })
            }
        }
    },[showHsnSlider])
    const onInputChange = searchVal => {
        setHsnSearchVal(searchVal);
        if (searchVal.length > 1) {
            toggleSearchLoaderFlag(true);
            axios
                .get("/marketplace/static/php/web/common_api.php", {
                    params: {
                        action: 'getGstFromHsn',
                        currentPage: 1,
                        searchBy: '',
                        searchKey: searchVal
                    }
                })
                .then(res => {
                    toggleSearchLoaderFlag(false);
                    let searchRslts = res.data && res.data.docs;
                    if (searchRslts && searchRslts.length) {
                        setHsnSacData(searchRslts);
                    } else {
                        setHsnSacData([]);
                        console.log("No Result Found");
                    }
                });
        } else {
            setHsnSacData([]);
        }
    };

    const setTaxesToZones = (product) => {
        // if (zoneIds && zoneIds.length) {
        //     for (let i = zoneIds.length - 1 ; i >= 0; i--) {
        //         let zone = zoneIds[i];
                // for (var j = outletData.length - 1; j >= 0; j--) {
                //     var outlet = outletData[j];
                //     if (zone.outletIds.indexOf(outlet.outletId) != -1) {
                //         var selectedTax = getApplicableTax({
                //             rate: product.gst,
                //             outlet: outlet,
                //             zone: zone,
                //             listOfSalesTax: taxDetails
                //         });
                //         if (selectedTax) {
                //             onItemSelect(zone.zoneName, selectedTax.taxName + ' @ ' + selectedTax.taxRate + '%');
                //             break;
                //         }
                //     }
                // }
            //     let selectedTax = getApplicableTax({
            //         rate: product.gst,
            //         state_id: session.state_id,
            //         state: session.state,
            //         zone: zone,
            //         listOfSalesTax: taxDetails
            //     });
            //     if (selectedTax) {
            //         onItemSelect(zone.zoneName, selectedTax.taxName + ' @ ' + selectedTax.taxRate + '%');
            //         continue;
            //     }
            // }
        // }
        const tax = String(product.gst).includes('.') ? product.gst : product.gst + '%'
        onItemSelect('salestax', tax);
    }

    const hsnSliderData = {
        showOnlySearch: true,
        hintText: 'Enter HSN/SAC',
        search: {
            class: "search-text",
            placeholder: "Search HSN/SAC Code",
            loader: searchLoaderFlag,
            onChange: onInputChange,
            value: hsnSearchVal,
            minLength: 1,
			hideScanner: true
        },
        onHidden: e => {
            setHsnSlider(false);
        },
        autoSuggestion: {
            data: hsnSacData,
            renderListItem: (item, index, closeHsnSlider) => {
                let elementProps = {
                    item: item,
                    searchKey: hsnSearchVal,
                    onEleClick: (item) => {
                        onInputChange(item.hsn_code);
                        onItemSelect('HSN/SAC', item.hsn_code);
                        if(props.productData.productId == 'ADD_PRODUCT'?!props.productData.taxPresent:props.productData.taxEditable){
                            setTaxesToZones(item);
                        }
                        closeHsnSlider();
                    },
                    rippleColor: rippleColor,
                    manageTaxes: props.manageTaxes
                }
                return (
                    <SearchResults {...elementProps} />
                )
            }
        },
        manageTaxes: props.manageTaxes
    };


    return (
		<SliderWrapper
			header={{
				heading: heading || 'Manage Taxes',
				variant: headerVariant || 'secondary',
				rightIcons: []
			}}
			onHidden={show => {
				onHidden();
			}}
			footer={{
				btnProps: [
					{
						children: 'Save',
						clickHandler: () => {
							prepareServiceData();
						},
						size: 'lg'
					}
				]
			}}
		>
			<div className={styles['tax-slider']}>
				{((taxLabel && taxLabel.length) ||
                (purchaseTaxLabel && purchaseTaxLabel.length)) &&
					inputElements.map((ele, index) =>
						ele.isSelect && !props.manageTaxes ? (
							<InputWithDropDown
								manageTaxes={true}
								{...ele}
								listItems={ele.fieldName && ele.fieldName == "SalesTaxRate" ? taxLabel : purchaseTaxLabel}
							/>
						) : ele.isSelect && props.manageTaxes ? (
                            <>
                                <Dropdown
                                    className={`input-ele  ${styles['manage-tax-label']} ${errors[ele.label]?'error-box':''} ${(((props.productData.isTempProd && props.productData.taxPresent && ele.value)|| (!props.productData.taxEditable && props.productData.productId !='ADD_PRODUCT' )) && !ele?.ignoreDisabling) ? styles['disable-div']:''}`}
                                    optionList={getDropDownOptions(ele.fieldName && ele.fieldName == "SalesTaxRate" ? taxLabel : purchaseTaxLabel, ele.label)}
                                    rightIconClass = {` ${((props.productData.isTempProd && props.productData.taxPresent && ele.value)|| (!props.productData.taxEditable && props.productData.productId !='ADD_PRODUCT' )) && !ele.ignoreDisabling ? '':'icon-pagination-down'}`}
                                    {...ele}
                                    onChange={(e,val) => {
                                        if(isMobile){
                                            let value = val.key
                                            if(value == 'Select Tax')
                                                value = '';//Clear selection
                                            onItemSelect(ele.serviceKey, value);
                                        }else{
                                            let value = e.key
                                            if(value == 'Select Tax')
                                                value = '';//Clear selection
                                            onItemSelect(ele.serviceKey, value);
                                        }
                                        
                                    }}
                                    placeholder={ele.label}
                                    value={ele.value}
                                    label={ele.label}
                                    error={errors[ele.label]}
                                    errorMessage={errors[ele.label]}
                                    defaultWeb={true}
                                />
                            </>
						) : (
							<InputWithMovingLabel {...ele} ref={hsnRef} />
						)
					)}
			</div>
			{showLoader && (
				<div className='loader-div'>
					<Loader svgLoader={true} variant='default' />
				</div>
			)}
			{showHsnSlider && (
				<div className={styles['hsnSliderContainer']}>
					<ItemListSlider {...hsnSliderData} />
				</div>
			)}
		</SliderWrapper>
	);
}

const mapStateToProps = state => {
    return {
        outletData: state.permissions.outletData,
        supplierType: state.permissions.supplierType,
        taxData: state.permissions.taxData,
        taxZoneData: state.permissions.taxZones,
        purchaseTaxData: state.permissions.purchaseTaxData,
        session: state.session,
        psv_node_id: state.products.editProduct.psv_node_id || state.products.editProduct.leafId,
        productData: state.products.editProduct
    };
};
export default connect(mapStateToProps, {showMessage: toastMessageActions.showMessage})(TaxSlider);